import { render, staticRenderFns } from "./TabelaCadastrosVuetfy.vue?vue&type=template&id=d193149e&scoped=true"
import script from "./TabelaCadastrosVuetfy.vue?vue&type=script&lang=js"
export * from "./TabelaCadastrosVuetfy.vue?vue&type=script&lang=js"
import style0 from "./TabelaCadastrosVuetfy.vue?vue&type=style&index=0&id=d193149e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d193149e",
  null
  
)

export default component.exports